



// import { QRCodeCanvas } from "qrcode.react";
// import { Box, Button, Grid, Typography, Container, Input, Grid2, Card } from "@mui/material";
// import CameraIcon from '@mui/icons-material/CameraAlt';
// import { useEffect, useRef, useState } from "react";
// import sca1 from '../images/sca1.jpg'
// import sca2 from '../images/sca2.png'
// import sca3 from '../images/sca3.png'
// import qrcodeClassic from '../images/qrcodeclassic.png';
// import qrcodeRounded from '../images/qrcoderounded.png';
// import qrcodeThin from '../images/qrcodethin.png';
// import qrcodeSmooth from '../images/qrcodesmooth.png';

// const styleMap = {
//   classic: qrcodeClassic,
//   rounded: qrcodeRounded,
//   thin: qrcodeThin,
//   smooth: qrcodeSmooth,
// };




// const QRCodeGenerator = ({ inputValue }) => {
//   const [backgroundColor, setBackgroundColor] = useState("#ffffff");
//   const [foregroundColor, setForegroundColor] = useState("#000000");
//   const [logo, setLogo] = useState(null);
//   const [qrCode, setQrCode] = useState(null);
//   const [qrCodeId, setQrCodeId] = useState(null);

//   const qrCanvasRef = useRef(inputValue); // Create ref for QR Code canvas

//   // Handle logo upload
//   const handleLogoUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         setLogo(event.target.result);  // Set the logo as base64 URL
//       };
//       reader.readAsDataURL(file);  // Read the file as data URL
//     }
//   };


//   const handleLogoClick = (selectedLogo) => {
//     setLogo(selectedLogo);
//   };

//   const [qrCodeI,setqrCodeI]=useState()




//   // const handleGenerateQRCode = async () => {
//   //   if (!inputValue) {
//   //     alert("Please enter a valid input value");
//   //     return;
//   //   }

//   //  // Capture the QR code as a base64 string
//   //  // Store the generated QR code

//   //  if (!qrCanvasRef.current) {
//   //   alert("QR canvas not found");
//   //   return;
//   // }

//   // // Get the userId from sessionStorage
//   // const userId = sessionStorage.getItem('userId');

//   // // Wait for the canvas to be updated before capturing the image
//   // const qrCodeImageBase64 = qrCanvasRef.current.toDataURL();

//   // // Check if canvas data is generated
//   // if (!qrCodeImageBase64 || qrCodeImageBase64 === "data:,") {
//   //   alert("Failed to generate QR code image");
//   //   return;
//   // }

//   //   const response = await fetch('https://qrapi.emedha.in/generate-qrcode', {
//   //     method: 'POST',
//   //     headers: {
//   //       'Content-Type': 'application/json',
//   //     },
//   //     body: JSON.stringify({
//   //       userId,
//   //       url: inputValue,
//   //       qrcodeImage: qrCodeImageBase64,
//   //     }),
//   //   });

//   //   const data = await response.json();
//   //   if (response.ok) {
//   //     const qrCodeId = data.qrCodeId;  // Extract the qrCodeId from the response

//   //   // Now use the qrCodeId to create the QR code that will be tracked
//   //   const qrCodeTrackingUrl = `https://qrapi.emedha.in/track/${qrCodeId}`;

//   //   // Generate the QR code using this tracking URL
//   // //

//   //     alert('QR Code saved successfully!');
//   //     setQrCode(qrCodeTrackingUrl); 
//   //   } else {
//   //     alert('Error saving QR Code');
//   //   }
//   // };


//   const [pendingUpload, setPendingUpload] = useState(false);
//   const [qrCodeImage, setQrCodeImage] = useState(null);

//   const [selectedStyle, setSelectedStyle] = useState("classic");


// useEffect(() => {
//   if (pendingUpload && qrCode) {
//     // QR code is rendered now, capture the canvas
//     setTimeout(async () => {
//       const canvas = document.querySelector('canvas');
//       if (!canvas) {
//         alert('QR canvas not found');
//         return;
//       }

//       const qrCodeImageBase64 = canvas.toDataURL();

//       if (!qrCodeImageBase64 || qrCodeImageBase64 === 'data:,') {
//         alert('Failed to generate QR code image');
//         return;
//       }

//       const userId = sessionStorage.getItem('userId');

//       setQrCodeImage(qrCodeImageBase64);

//       const response = await fetch('https://qrapi.emedha.in/generate-qrcode', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           userId,
//           url: inputValue,
//           qrcodeImage: qrCodeImageBase64,
//         }),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         alert('QR Code saved successfully!');
//         setQrCodeImage(qrCodeImageBase64);
//       } else {
//         alert('Error saving QR Code');
//       }

//       setPendingUpload(false);
//     }, 500); // Delay to ensure rendering
//   }
// }, [pendingUpload, qrCode]);


// const handleGenerateQRCode = async () => {
//   if (!inputValue) {
//     alert("Please enter a valid input value");
//     return;
//   }

//   const userId = sessionStorage.getItem("userId");

//   const response = await fetch("https://qrapi.emedha.in/generate-qrcode", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       userId,
//       url: inputValue,
//       qrcodeImage: "", // Temporary placeholder
//     }),
//   });

//   const data = await response.json();
//   if (response.ok) {
//     const qrCodeId = data.qrCodeId;
//     const qrCodeTrackingUrl = `https://qrapi.emedha.in/track/${qrCodeId}`;
//     setQrCode(qrCodeTrackingUrl); // triggers useEffect
//     setPendingUpload(true);       // signals useEffect to capture canvas
//   } else {
//     alert("Error saving QR Code");
//   }
// };

//   console.log("qrCodeee",qrCode)


//   return (
//     <Container maxWidth="xl" sx={{ paddingTop: 5 }}>
//       <Grid container spacing={3}>
//         {/* Left Column: Color Pickers and Logo Upload */}
//         <Grid item xs={12} md={6}>
//           {/* Color Pickers */}
//           <Grid container spacing={1}>
//             <Grid item xs={12}>
//               <Typography variant="body2" sx={{ marginBottom: 3 }}>
//                 Background Color:
//               </Typography>
//               <input
//                 type="color"
//                 value={backgroundColor}
//                 onChange={(e) => setBackgroundColor(e.target.value)}
//                 style={{
//                   width: '100%',
//                   padding: '8px',
//                   borderRadius: '5px',
//                   border: '1px solid #ccc',
//                   cursor: 'pointer',
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Typography variant="body2" sx={{ marginBottom: 3 }}>
//                 Foreground Color:
//               </Typography>
//               <input
//                 type="color"
//                 value={foregroundColor}
//                 onChange={(e) => setForegroundColor(e.target.value)}
//                 style={{
//                   width: '100%',
//                   padding: '8px',
//                   borderRadius: '5px',
//                   border: '1px solid #ccc',
//                   cursor: 'pointer',
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Typography variant="body2" sx={{ marginBottom: 3 }}>
//                 Upload Logo:
//               </Typography>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleLogoUpload}
//                 style={{
//                   width: '100%',
//                   padding: '8px',
//                   borderRadius: '5px',
//                   border: '1px solid #ccc',
//                   backgroundColor: '#f8f8f8',
//                   cursor: 'pointer',
//                 }}
//               />
//             </Grid>
//               {/* <Grid container spacing={3} >
//         {/* Image 1 */}
//         <Grid item xs={4} md={2} style={{margin:10}}>
//           <Box
//             onClick={() => handleLogoClick(sca1)}  // Set sca1 as the selected logo
//             sx={{
//               cursor: 'pointer',
//               border: logo === sca1 ? '3px solid #007bff' : '1px solid #ccc',
//               padding: '8px',
//               borderRadius: '5px',
//               textAlign: 'center',
//             }}
//           >
//             <img src={sca1} alt="Logo 1" style={{ width: '100%', height: 'auto', borderRadius: '5px' }} />
//           </Box>
//         </Grid>

//         {/* Image 2 */}
//         <Grid item xs={4} md={2} style={{margin:10}}>
//           <Box
//             onClick={() => handleLogoClick(sca2)}  // Set sca2 as the selected logo
//             sx={{
//               cursor: 'pointer',
//               border: logo === sca2 ? '3px solid #007bff' : '1px solid #ccc',
//               padding: '8px',
//               borderRadius: '5px',
//               textAlign: 'center',
//             }}
//           >
//             <img src={sca2} alt="Logo 2" style={{ width: '100%', height: 'auto', borderRadius: '5px' }} />
//           </Box>
//         </Grid>

//         {/* Image 3 */}
//         <Grid item xs={4} md={2} style={{margin:10}}>
//           <Box
//             onClick={() => handleLogoClick(sca3)}  // Set sca3 as the selected logo
//             sx={{
//               cursor: 'pointer',
//               border: logo === sca3 ? '3px solid #007bff' : '1px solid #ccc',
//               padding: '8px',
//               borderRadius: '5px',
//               textAlign: 'center',
//             }}
//           >
//             <img src={sca3} alt="Logo 3" style={{ width: '100%', height: 'auto', borderRadius: '5px' }} />
//           </Box>
//         </Grid> 

// <Box sx={{ marginTop: 4 }}>
//   <Typography variant="h6" sx={{ color: "#0F172A", marginBottom: 2 }}>
//     Pre-made Designs
//   </Typography>
//   <Grid container spacing={2}>
//     {["classic", "rounded", "thin", "smooth"].map((style) => (
//       <Grid item xs={6} sm={3} key={style}>
//         <Card
//           onClick={() => setSelectedStyle(style)}
//           sx={{
//             border: selectedStyle === style ? "2px solid #1976d2" : "1px solid #ccc",
//             borderRadius: 2,
//             cursor: "pointer",
//             textAlign: "center",
//             padding: 2,
//             "&:hover": {
//               border: "2px solid #1976d2",
//             },
//           }}
//         >
//           {/* Replace with real thumbnails if you have them */}
//        <img
//   src={styleMap[style]}
//   alt={`${style} QR style`}
//   style={{ width: '100%', height: 'auto', marginBottom: 10 }}
// />
//           <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
//             {style}
//           </Typography>
//         </Card>
//       </Grid>
//     ))}
//   </Grid>
// </Box>


//           </Grid>



//           <Box sx={{ textAlign: 'right', marginTop: 6, marginLeft: 1 }}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleGenerateQRCode}
//               sx={{
//                 padding: '10px 20px',
//                 fontSize: '16px',
//                 backgroundColor: '#007bff',
//                 '&:hover': {
//                   backgroundColor: '#0056b3',
//                 },
//               }}
//             >
//               Generate QR Code
//             </Button>
//           </Box>
//         </Grid>

//         {/* Right Column: QR Code Preview and Buttons */}
//         <Grid item xs={12} md={6}>
//           {/* QR Code Preview */}
//           <Box sx={{ textAlign: 'center', marginBottom: 4 ,padding:'10px', backgroundColor:'#007bff' , borderRadius:'8px'}}>
//             <QRCodeCanvas
//               ref={qrCanvasRef}
//               value={qrCode || ' '}
//               size={256}
//               bgColor={backgroundColor}
//               fgColor={foregroundColor}
//               imageSettings={
//                 logo
//                   ? {
//                       src: logo,  // Base64 URL for the logo
//                       x: undefined,  // Centered by default
//                       y: undefined,  // Centered by default
//                       height: 40,     // Reduce logo size for better clarity
//                       width: 40,      // Reduce logo size for better clarity
//                       excavate: true, // Excavation to allow logo in the QR code
//                     }
//                   : null
//               }
//             />
//           </Box>

//           {/* Download QR Code Button */}
//           {qrCode && (
//             <Box sx={{ textAlign: 'center', marginTop: 3 }}>
//               <Typography variant="body1" sx={{ marginBottom: 2 }}>
//                 Download Your QR Code:
//               </Typography>
//               <a href={qrCodeImage} download="qrcode.png">
//                 <Button
//                   variant="contained"
//                   color="secondary"
//                   sx={{
//                     padding: '10px 20px',
//                     fontSize: '16px',
//                     backgroundColor: '#28a745',
//                     '&:hover': {
//                       backgroundColor: '#218838',
//                     },
//                   }}
             
//                 >
//                   Download QR Code
//                 </Button>
//               </a>
//             </Box>
//           )}
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };




// export default QRCodeGenerator;




// import React, { useEffect, useRef, useState } from "react";
// import QRCodeStyling from "qr-code-styling";

// const styles = ["dots", "rounded", "classy", "classy-rounded", "square", "extra-rounded"];

// const QRCodeGenerator = ({ inputValue }) => {
//   const qrRef = useRef(null);
//   const qrCode = useRef(null);

 
//   const [selectedStyle, setSelectedStyle] = useState("dots");

//   // Initialize QR code
//   useEffect(() => {
//     qrCode.current = new QRCodeStyling({
//       width: 300,
//       height: 300,
//       data: inputValue,
//       dotsOptions: {
//         color: "#000",
//         type: selectedStyle,
//       },
//       backgroundOptions: {
//         color: "#fff",
//       },
//       imageOptions: {
//         crossOrigin: "anonymous",
//         margin: 10,
//       },
//     });

//     if (qrRef.current) {
//       qrCode.current.append(qrRef.current);
//     }
//   }, []);

//   // Update QR code when URL or style changes
//   useEffect(() => {
//     qrCode.current.update({
//       data: inputValue,
//       dotsOptions: {
//         type: selectedStyle,
//       },
//     });
//   }, [inputValue, selectedStyle]);

//   // Download QR code
//   const downloadQRCode = async () => {
//     const blob = await qrCode.current.getRawData("png");
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "qr-code.png";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Send QR code to API
//   const sendQRCodeToAPI = async () => {
//     const blob = await qrCode.current.getRawData("png");
//     const reader = new FileReader();
//     reader.onloadend = async () => {
//       const base64data = reader.result;

//       const response = await fetch("https://qrapi.emedha.in/generate-qrcode", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           userId: sessionStorage.getItem("userId"),
//           url: inputValue,
//           qrcodeImage: base64data,
//         }),
//       });

//       if (response.ok) {
//         alert("QR Code sent to API successfully!");
//       } else {
//         alert("Error sending QR Code to API.");
//       }
//     };
//     reader.readAsDataURL(blob);
//   };

//   return (
//     <div style={{ padding: 20, fontFamily: "Arial" }}>
//       <h2>QR Code Generator</h2>

//       <div style={{ marginBottom: 10 }}>
//         <label>Choose Style: </label>
//         <select
//           value={selectedStyle}
//           onChange={(e) => setSelectedStyle(e.target.value)}
//           style={{ padding: 6, fontSize: 16 }}
//         >
//           {styles.map((style) => (
//             <option key={style} value={style}>
//               {style}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div ref={qrRef} style={{ marginBottom: 20 }} />

//       <button onClick={downloadQRCode} style={buttonStyle}>
//         Download PNG
//       </button>

//       <button onClick={sendQRCodeToAPI} style={{ ...buttonStyle, marginLeft: 10 }}>
//         Send to API
//       </button>
//     </div>
//   );
// };

// const buttonStyle = {
//   padding: "10px 20px",
//   fontSize: 16,
//   backgroundColor: "#952929",
//   color: "#fff",
//   border: "none",
//   borderRadius: 6,
//   cursor: "pointer",
// };

// export default QRCodeGenerator;


import React, { useEffect, useRef, useState } from "react";
import QRCodeStyling from "qr-code-styling";

// Predefined logos (replace with your actual image imports or URLs)
import sca1 from "../images/sca1.jpg";
import sca2 from "../images/sca2.png";
import sca3 from "../images/sca3.png";
import Swal from 'sweetalert2';


const styless = ["dots", "rounded", "classy", "classy-rounded", "square", "extra-rounded"];
const predefinedLogos = [sca1, sca2, sca3];

const QRCodeGenerator = ({ inputValue }) => {
  const qrRef = useRef(null);
  const qrCode = useRef(null);

  // States for customization
  const [qrCodeId, setQrCodeId] = useState(null);
const [trackingUrl, setTrackingUrl] = useState("");

  const [selectedStyle, setSelectedStyle] = useState("dots");
  const [bgColor, setBgColor] = useState("#ffffff");
  const [fgColor, setFgColor] = useState("#000000");
  const [selectedPreLogo, setSelectedPreLogo] = useState(null);
  const [customLogo, setCustomLogo] = useState(null);

  const [isOpenDownload , setOpenDownload]=useState(false)


  console.log('inputValue', inputValue)

  // Initialize QR code once
  useEffect(() => {
    qrCode.current = new QRCodeStyling({
      width: 300,
      height: 300,
      data: inputValue,
      dotsOptions: {
        color: fgColor,
        type: selectedStyle,
      },
      backgroundOptions: {
        color: bgColor,
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 10,
      },
      image: customLogo
        ? URL.createObjectURL(customLogo)
        : selectedPreLogo
        ? selectedPreLogo
        : undefined,
    });

    if (qrRef.current) {
      qrRef.current.innerHTML = ""; // Clear previous QR if any
      qrCode.current.append(qrRef.current);
    }

    // Clean up object URL if custom logo changes later
    return () => {
      if (customLogo) URL.revokeObjectURL(URL.createObjectURL(customLogo));
    };
  }, []);

  // Update QR code on changes
  useEffect(() => {
    qrCode.current.update({
      data: inputValue,
      dotsOptions: {
        color: fgColor,
        type: selectedStyle,
      },
      backgroundOptions: {
        color: bgColor,
      },
      image: customLogo
        ? URL.createObjectURL(customLogo)
        : selectedPreLogo
        ? selectedPreLogo
        : undefined,
    });
  }, [inputValue, selectedStyle, fgColor, bgColor, customLogo, selectedPreLogo]);

  // Logo upload handler
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCustomLogo(file);
      setSelectedPreLogo(null); // Clear predefined logo selection
    }
  };

  // Download QR code PNG
  const downloadQRCode = async () => {
    const blob = await qrCode.current.getRawData("png");
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "qr-code.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Send QR code to API
  // const sendQRCodeToAPI = async () => {
  //   const blob = await qrCode.current.getRawData("png");
  //   const reader = new FileReader();
  //   reader.onloadend = async () => {
  //     const base64data = reader.result;

  //     const response = await fetch("https://qrapi.emedha.in/generate-qrcode", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         userId: sessionStorage.getItem("userId"),
  //         url: inputValue,
  //         qrcodeImage: base64data,
  //       }),
  //     });

  //     if (response.ok) {
  //       alert("QR Code sent to API successfully!");
  //     } else {
  //       alert("Error sending QR Code to API.");
  //     }
  //   };
  //   reader.readAsDataURL(blob);
  // };

//   const sendQRCodeToAPI = async () => {
//   const blob = await qrCode.current.getRawData("png");
//   const reader = new FileReader();

//   reader.onloadend = async () => {
//     const base64data = reader.result;

//     // First, generate qrCodeId
//     const userId = sessionStorage.getItem("userId");

//     const initialRes = await fetch("https://qrapi.emedha.in/generate-qrcode", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         userId,
//         url: inputValue,
//         qrcodeImage: "", // initial request without image
//       }),
//     });

//     const result = await initialRes.json();

//     if (!initialRes.ok || !result.qrCodeId) {
//       alert("Error creating QR Code ID");
//       return;
//     }

//     const qrCodeId = result.qrCodeId;
//     const trackingUrl = `https://qrapi.emedha.in/track/${qrCodeId}`;

//     setQrCodeId(qrCodeId);
//     setTrackingUrl(trackingUrl);

//     // Now update QR with new tracking URL
//     qrCode.current.update({
//       data: trackingUrl,
//       dotsOptions: {
//         color: fgColor,
//         type: selectedStyle,
//       },
//       backgroundOptions: {
//         color: bgColor,
//       },
//       image: customLogo
//         ? URL.createObjectURL(customLogo)
//         : selectedPreLogo
//         ? selectedPreLogo
//         : undefined,
//     });

//     // Send the final image to API
//     const finalRes = await fetch("https://qrapi.emedha.in/generate-qrcode", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         userId,
//         url: inputValue,
//         qrcodeImage: base64data,
//       }),
//     });

//     if (finalRes.ok) {
//       alert("QR Code generated and image uploaded!");
      
//       setOpenDownload(true)
//     } else {
//       alert("QR Code created but image upload failed.");
//     }
//   };

//   reader.readAsDataURL(blob);
// };

//28-05-2025

// const sendQRCodeToAPI = async () => {
//   const userId = sessionStorage.getItem("userId");

//   // 1. Generate QR Code ID
//   const initialRes = await fetch("http://localhost:5000/generate-qrcode", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({
//       userId,
//       url: inputValue,
//       qrcodeImage: "", // Initial placeholder
//     }),
//   });

//   const result = await initialRes.json();

//   if (!initialRes.ok || !result.qrCodeId) {
//     alert("Error creating QR Code ID");
//     return;
//   }

//   const qrCodeId = result.qrCodeId;
//   const trackingUrl = `https://qrapi.emedha.in/track/${qrCodeId}`;

//   setQrCodeId(qrCodeId);
//   setTrackingUrl(trackingUrl);

//   // 2. Update the QR Code with tracking URL
//   qrCode.current.update({
//     data: trackingUrl,
//     dotsOptions: {
//       color: fgColor,
//       type: selectedStyle,
//     },
//     backgroundOptions: {
//       color: bgColor,
//     },
//     image: customLogo
//       ? URL.createObjectURL(customLogo)
//       : selectedPreLogo
//       ? selectedPreLogo
//       : undefined,
//   });

//   // 3. WAIT for update, then generate updated PNG blob
//   setTimeout(async () => {
//     const updatedBlob = await qrCode.current.getRawData("png");
//     const reader = new FileReader();

//     reader.onloadend = async () => {
//       const base64data = reader.result;

//       // 4. Send final QR image with tracking URL encoded
//       const finalRes = await fetch("http://localhost:5000/generate-qrcode", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           userId,
//           url: inputValue, // This is the final redirect target, like sms:
//           qrcodeImage: base64data,
//         }),
//       });

//       if (finalRes.ok) {
//         alert("✅ QR Code generated and image uploaded!");
//         setOpenDownload(true);
//       } else {
//         alert("QR Code created but image upload failed.");
//       }
//     };

//     reader.readAsDataURL(updatedBlob);
//   }, 300); // Wait briefly to ensure update is applied
// };

const sendQRCodeToAPI = async () => {
  const userId = sessionStorage.getItem("userId");

  // 1. Generate QR Code ID
  const initialRes = await fetch("https://qrapi.emedha.in/generate-qrcode", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      userId,
      url: inputValue,
      qrcodeImage: "", // Initial placeholder
    }),
  });

  const result = await initialRes.json();

  // Handle initial QR creation errors
  if (!initialRes.ok || !result.qrCodeId) {
    Swal.fire({
      icon: 'error',
      title: 'QR Code Generation Failed',
      text: result?.error || 'Error creating QR Code ID',
    });
    return;
  }

  // Proceed with QR code update
  const qrCodeId = result.qrCodeId;
  const trackingUrl = `https://qrapi.emedha.in/track/${qrCodeId}`;

  setQrCodeId(qrCodeId);
  setTrackingUrl(trackingUrl);

  // 2. Update the QR Code with tracking URL
  qrCode.current.update({
    data: trackingUrl,
    dotsOptions: {
      color: fgColor,
      type: selectedStyle,
    },
    backgroundOptions: {
      color: bgColor,
    },
    image: customLogo
      ? URL.createObjectURL(customLogo)
      : selectedPreLogo
      ? selectedPreLogo
      : undefined,
  });

  // 3. WAIT for update, then generate updated PNG blob
  setTimeout(async () => {
    const updatedBlob = await qrCode.current.getRawData("png");
    const reader = new FileReader();

    reader.onloadend = async () => {
      const base64data = reader.result;

      // 4. Send final QR image with tracking URL encoded
      const finalRes = await fetch("https://qrapi.emedha.in/generate-qrcode", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          url: inputValue, // Final URL to be encoded in QR
          qrcodeImage: base64data,
        }),
      });

      const finalResult = await finalRes.json();

      if (finalRes.ok) {
        Swal.fire({
          icon: 'success',
          title: 'QR Code Created!',
          text: '✅ QR Code generated and image uploaded successfully!',
        });
        setOpenDownload(true);
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Image Upload Failed',
          text: finalResult?.error || 'QR Code created, but image upload failed.',
        });
      }
    };

    reader.readAsDataURL(updatedBlob);
  }, 300);
};

  return (
    // <div style={{ padding: 20, fontFamily: "Arial" }}>
    //   <h2>QR Code Generator</h2>


    //   <div style={{ marginBottom: 10 }}>
    //     <label>Choose Style: </label>
    //     <select
    //       value={selectedStyle}
    //       onChange={(e) => setSelectedStyle(e.target.value)}
    //       style={{ padding: 6, fontSize: 16 }}
    //     >
    //       {styles.map((style) => (
    //         <option key={style} value={style}>
    //           {style}
    //         </option>
    //       ))}
    //     </select>
    //   </div>

    //   {/* Background & Foreground Colors */}
    //   <div style={{ marginBottom: 10 }}>
    //     <label>Background Color: </label>
    //     <input
    //       type="color"
    //       value={bgColor}
    //       onChange={(e) => setBgColor(e.target.value)}
    //       style={{ marginRight: 20 }}
    //     />

    //     <label>Foreground Color: </label>
    //     <input type="color" value={fgColor} onChange={(e) => setFgColor(e.target.value)} />
    //   </div>


    //   <div style={{ marginBottom: 10 }}>
    //     <label>Upload Logo: </label>
    //     <input type="file" accept="image/*" onChange={handleLogoUpload} />
    //   </div>

 
    //   <div style={{ marginBottom: 10 }}>
    //     <label>Select Predefined Logo:</label>
    //     <div style={{ display: "flex", gap: 10, marginTop: 5 }}>
    //       {predefinedLogos.map((logo, idx) => (
    //         <img
    //           key={idx}
    //           src={logo}
    //           alt={`logo-${idx}`}
    //           style={{
    //             width: 50,
    //             height: 50,
    //             border: selectedPreLogo === logo ? "3px solid #952929" : "1px solid #ccc",
    //             borderRadius: 6,
    //             cursor: "pointer",
    //             objectFit: "contain",
    //           }}
    //           onClick={() => {
    //             setSelectedPreLogo(logo);
    //             setCustomLogo(null);
    //           }}
    //         />
    //       ))}
    //     </div>
    //   </div>

    //   {/* QR code display */}
    //   <div ref={qrRef} style={{ marginBottom: 20 }} />

 

    //   <button onClick={sendQRCodeToAPI} style={{ ...buttonStyle, marginLeft: 10 }}>
    //     Generate QR
    //   </button>
    //        {isOpenDownload && 
    //   <button onClick={downloadQRCode} style={buttonStyle}>
    //     Download PNG
    //   </button>}
    // </div>
<div style={styles.wrapper}>
  {/* Left Panel: QR Settings */}
  <div style={styles.leftPanel}>
    <h2 style={styles.heading}>🎯 QR Code Generator</h2>

    {/* Style Selection */}
    <div style={styles.formGroup}>
      <label style={styles.label}>Choose Style:</label>
      <select
        value={selectedStyle}
        onChange={(e) => setSelectedStyle(e.target.value)}
        style={styles.select}
      >
        {styless.map((style) => (
          <option key={style} value={style}>
            {style}
          </option>
        ))}
      </select>
    </div>

    {/* Color Pickers */}
    <div style={styles.formGroup}>
      <label style={styles.label}>Background Color:</label>
      <input
        type="color"
        value={bgColor}
        onChange={(e) => setBgColor(e.target.value)}
        style={styles.colorInput}
      />

      <label style={{ ...styles.label, marginLeft: 20 }}>Foreground Color:</label>
      <input
        type="color"
        value={fgColor}
        onChange={(e) => setFgColor(e.target.value)}
        style={styles.colorInput}
      />
    </div>

    {/* Logo Upload */}
    <div style={styles.formGroup}>
      <label style={styles.label}>Upload Logo:</label>
      <input type="file" accept="image/*" onChange={handleLogoUpload} style={styles.fileInput} />
    </div>

    {/* Predefined Logos */}
    <div style={styles.formGroup}>
      <label style={styles.label}>Select Predefined Logo:</label>
      <div style={styles.logoContainer}>
        {predefinedLogos.map((logo, idx) => (
          <img
            key={idx}
            src={logo}
            alt={`logo-${idx}`}
            style={{
              ...styles.logo,
              border: selectedPreLogo === logo ? "3px solid #952929" : "1px solid #ccc",
            }}
            onClick={() => {
              setSelectedPreLogo(logo);
              setCustomLogo(null);
            }}
          />
        ))}
      </div>
    </div>
  </div>

  {/* Right Panel: QR Preview & Buttons */}
  <div style={styles.rightPanel}>
    <div ref={qrRef} style={styles.qrBox} />

    <div style={styles.buttonGroup}>
      <button onClick={sendQRCodeToAPI} style={styles.primaryButton}>
        🚀 Generate QR
      </button>
      {isOpenDownload && (
        <button onClick={downloadQRCode} style={styles.primaryButton}>
          📥 Download PNG
        </button>
      )}
    </div>
  </div>
</div>


  );
};

const buttonStyle = {
  padding: "10px 20px",
  fontSize: 16,
  backgroundColor: "#952929",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "row",
    gap: 30,
    padding: 30,
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f5f5f5",
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    marginTop: 20,
  },
  leftPanel: {
    flex: 1,
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
  },
  rightPanel: {
    flex: 1,
    textAlign: "center",
    paddingTop: 20,
  },
  heading: {
    fontSize: 24,
    color: "#952929",
    marginBottom: 20,
    fontWeight: "bold",
  },
  formGroup: {
    marginBottom: 20,
  },
  label: {
    display: "block",
    fontWeight: "bold",
    marginBottom: 8,
    color: "#333",
  },
  select: {
    padding: 8,
    width: "100%",
    fontSize: 16,
    borderRadius: 6,
    border: "1px solid #ccc",
  },
  colorInput: {
    padding: 4,
    width: 50,
    height: 40,
    border: "none",
    background: "none",
  },
  fileInput: {
    fontSize: 14,
  },
  logoContainer: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    marginTop: 8,
  },
  logo: {
    width: 50,
    height: 50,
    borderRadius: 6,
    cursor: "pointer",
    objectFit: "contain",
    transition: "border 0.3s",
  },
  qrBox: {
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    marginBottom: 20,
    minHeight: 250,
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: 20,
  },
  primaryButton: {
    padding: "10px 20px",
    backgroundColor: "#0056b3",
    color: "#fff",
    fontSize: 16,
    borderRadius: 6,
    border: "none",
    cursor: "pointer",
  },
  secondaryButton: {
    padding: "10px 20px",
    backgroundColor: "#ddd9d9",
    color: "#333",
    fontSize: 16,
    borderRadius: 6,
    border: "1px solid #999",
    cursor: "pointer",
  },
};



export default QRCodeGenerator;
